import { Action } from "@ngrx/store";
import { Rating } from "@edp-models/rating.model";

export enum ERatingActions {
    GetRatingStatus = "[Rating] Get rating status",
    SaveRatingStatus = "[Rating] Save rating status",
    SubmitRating = "[Rating] Submit rating",
}

export class GetRatingStatus implements Action {
    public readonly type = ERatingActions.GetRatingStatus;
}

export class SaveRatingStatus implements Action {
    public readonly type = ERatingActions.SaveRatingStatus;
    constructor(public payload: Rating) {}
}

export class SubmitRating implements Action {
    public readonly type = ERatingActions.SubmitRating;
    constructor(public payload: Rating) {}
}

export type RatingActions = GetRatingStatus | SubmitRating | SaveRatingStatus;
